// Header Navigation Helper
(() => {
  const ANIMATION_DELAY = 50; 

  function handleDrawerClick(evt) {
    const currentPanel = evt.target.closest('.panel');
    const nextPanel = currentPanel?.nextElementSibling;

    if (!nextPanel || !nextPanel.classList.contains('panel')) return;

    setTimeout(() => {
      const visibleWrapper = nextPanel.querySelector('.panel__wrapper:not([hidden])');
      
      if (!visibleWrapper) return;

      const forwardButtons = visibleWrapper.querySelectorAll('button:has(.circle-chevron)');

      if (forwardButtons.length === 1) {
        visibleWrapper.style.visibility = 'hidden';
        
        forwardButtons[0].click();
      } else {
        visibleWrapper.style.visibility = '';
      }
    }, ANIMATION_DELAY);
  }

  function handleDrawerBackClick(evt) {
    const currentPanel = evt.target.closest('.panel');
    const prevPanel = currentPanel?.previousElementSibling;

    if (!prevPanel || !prevPanel.classList.contains('panel')) return;

    setTimeout(() => {
      const visibleWrapper = prevPanel.querySelector('.panel__wrapper:not([hidden])');
      
      if (!visibleWrapper) return;

      const forwardButtons = visibleWrapper.querySelectorAll('button:has(.circle-chevron)');
      
      if (forwardButtons.length === 1) {
        visibleWrapper.style.visibility = 'hidden';

        const backButton = visibleWrapper.querySelector('button:has(.icon-chevron-left)');
        if (backButton) backButton.click();
      }
    }, ANIMATION_DELAY);
  }

  document.querySelectorAll('navigation-drawer .panel button:has(.circle-chevron)').forEach((button) => {
    button.addEventListener('click', handleDrawerClick);
  });

  document.querySelectorAll('navigation-drawer .panel button:has(.icon-chevron-left)').forEach((button) => {
    button.addEventListener('click', handleDrawerBackClick);
  });
})();